import styled from 'styled-components';

import { BottomSheet } from '@xingternal/bottom-sheet';
import { Meta } from '@xingternal/typography';
import { Divider } from '@xingternal/divider';
import { spaceL, spaceXL, spaceXXL } from '@xingternal/tokens';

export const StyledMeta = styled(Meta)`
  margin: 0;
  padding: ${spaceXL} ${spaceXXL} 0;
  z-index: 500;
`;

export const StyledBottomSheet = styled(BottomSheet)`
  overflow-y: scroll;
  width: 100%;
`;

export const StyledList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: ${spaceL};
`;

export const StyledListLast = styled(StyledList)`
  padding-bottom: ${spaceXL};
`;

export const StyledDivider = styled(Divider)`
  margin: 0 ${spaceXL};
`;
